// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__FWzM5","loading":"Button_loading__8AJeV"};